import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Icon, notification } from "antd";
import axios from "axios";
import moment from "moment";

import ExcelTabelaConteudos from "./_Aux/ExcelTabelaConteudos";
import ExcelTabelaConteudosMobile from "./_Aux/ExcelTabelaConteudosMobile";
import ModalViewer from "../../shared/components/Modals/ModalViewer";
import ModalLoading from "../../shared/components/Modals/ModalLoading";
import ModalHorarios from "./_Aux/ModalHorarios";

const openNotificationWithIcon = (type, message, description) => {
    notification[type]({
        message: message,
        description: description
    });
};

class ListaConteudos extends Component {
    state = {
        disciplinaId: localStorage.getItem("vista") === "TURMA" ? null : localStorage.getItem("codigo_curso"),
        periodoId: 0,
        //LOADING
        visibleLoading: false,
        //VIEWER
        visibleViewer: false,
        isModalVisible: false,
        startDate: undefined,
        endDate: undefined,
        docs: [],
        titulo: ""
    };
    componentDidMount() {
        this.listaDiarioEscolaridade();
    }

    exportarPdf = (disciplina, option, startDate, endDate, dataEmissao) => {
        this.setState(
            {
                visibleLoading: true
            },
            () => {
                axios({
                    method: "get",
                    url: "/api/pdf/sumarios",
                    params: {
                        id: disciplina,
                        start: moment(startDate).format("YYYY/MM/DD"),
                        end: moment(endDate).format("YYYY/MM/DD"),
                        tipo: option,
                        dataEmissao: moment(dataEmissao).format("YYYY/MM/DD")
                    }
                })
                    .then(response => {
                        const { url, fileName } = response.data;

                        this.setState({
                            visibleLoading: false,
                            visibleViewer: true,
                            docs: [{ uri: url, fileName }]
                        });
                    })
                    .catch(() => {
                        openNotificationWithIcon("error", "Erro", "Não foi possível exportar!");
                        this.setState({
                            visibleLoading: false
                        });
                    });
            }
        );
    };

    toggleModal = () => {
        this.setState(prevState => ({
            isModalVisible: !prevState.isModalVisible
        }));
    };

    listaDiarioEscolaridade = () => {
        axios({
            method: "get",
            url: "/api/aulas/lista-diario-escolaridade",
            params: {
                cursoId: localStorage.getItem("codigo_curso")
            }
        }).then(response => {
            this.setState({
                titulo: response.data.tituloVivencia ? "Vivências" : "Conteúdos"
            });
        });
    };

    render() {
        const {
            //LOADING
            visibleLoading,
            //VIEWER
            visibleViewer,
            docs,
            titulo
        } = this.state;

        return (
            <>
                <div className="container container-body">
                    <div className="bloco-curso-diario-opcoes" style={{ gap: 10 }}>
                        <h3 className="titulo-bloco">{titulo}</h3>
                        <div className="bloco-opcoes-esquerda">
                            <Link className={`botao-icon-detalhe botao-maior`} to="#" title="Visualizar" onClick={this.toggleModal}>
                                <Icon type="eye" />
                            </Link>
                            <Link
                                to={`/gerir-detalhe-turma/${this.props.match.params.turma}/${
                                    localStorage.getItem("vista") === "TURMA" ? "horario" : "horario-disciplina"
                                }`}
                                className="botao-secundario botao-secundario-redondo"
                                title="Voltar"
                                style={{ marginRight: 10, display: "flex", justifyContent: "center", alignItems: "center" }}
                            >
                                <Icon type="arrow-left" />
                            </Link>
                        </div>
                    </div>
                    <div className="curso-diario curso-diario-frequencia-desktop">
                        <ExcelTabelaConteudos
                            carregarPeriodoId={periodoId => this.setState({ periodoId })}
                            setDisciplinaId={disciplinaId => this.setState({ disciplinaId })}
                        />
                    </div>
                    <div className="curso-diario curso-diario-frequencia-mobile">
                        <ExcelTabelaConteudosMobile
                            carregarPeriodoId={periodoId => this.setState({ periodoId })}
                            setDisciplinaId={disciplinaId => this.setState({ disciplinaId })}
                        />
                    </div>
                </div>
                <ModalLoading visible={visibleLoading} text="A gerar documento..." />
                <ModalViewer visible={visibleViewer} docs={docs} onCancel={() => this.setState({ visibleViewer: false })} />
                <ModalHorarios
                    disciplina={this.state.disciplinaId}
                    visible={this.state.isModalVisible}
                    onClose={this.toggleModal}
                    onSelect={(option3, option1, option2, dataEmissao) => {
                        this.setState({
                            startDate: option2.start_date,
                            endDate: option2.end_date
                        });
                        this.exportarPdf(option3, option1, option2.start_date, option2.end_date, dataEmissao);
                    }}
                />
            </>
        );
    }
}

export default ListaConteudos;
